import { post } from "@insite/client-framework/Services/ApiService";

export async function GetPreviousPurchaseHistory(parameter: any): Promise<void> {
    try {
        const previouspurchasehistoryModel = await post<any>(`/api/previouspurchasehistory`, parameter);
        // await fetch(`/api/previouspurchasehistory`,parameter);
        return previouspurchasehistoryModel;
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
           console.log(error);
        }
        throw error;
    }
}
